(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[428],{

/***/ 688:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/keyword/go",
      function () {
        return __webpack_require__(5805);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(959);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) {
    var children = _param.children, className = _param.className, href = _param.href, _iconAlt = _param.iconAlt, iconAlt = _iconAlt === void 0 ? '' : _iconAlt, iconSrc = _param.iconSrc, _size = _param.size, size = _size === void 0 ? 'medium' : _size, theme = _param.theme, props = _objectWithoutProperties(_param, [
        "children",
        "className",
        "href",
        "iconAlt",
        "iconSrc",
        "size",
        "theme"
    ]);
    var ref1 = _slicedToArray(href ? [
        'a',
        {
            href: href
        }
    ] : [
        'button',
        {}
    ], 2), As = ref1[0], asProps = ref1[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(As, _objectSpread({}, props, asProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, _button_module_scss__WEBPACK_IMPORTED_MODULE_3__.button, _button_module_scss__WEBPACK_IMPORTED_MODULE_3__[size], _button_module_scss__WEBPACK_IMPORTED_MODULE_3__[theme]),
        ref: ref,
        children: [
            iconSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: _button_module_scss__WEBPACK_IMPORTED_MODULE_3__.icon,
                src: iconSrc,
                alt: iconAlt
            }),
            children
        ]
    })));
});
Button.displayName = 'Button';
Button.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    href: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    iconAlt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    iconSrc: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf([
        'small',
        'medium',
        'large',
        'full'
    ]),
    theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf([
        'blue',
        'light',
        'midnight',
        'outline'
    ]).isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 3576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cta; }
});

// UNUSED EXPORTS: CTAQRCode

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/qrcode.react/lib/index.js
var lib = __webpack_require__(1498);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/components/buttons/button.js
var buttons_button = __webpack_require__(6752);
;// CONCATENATED MODULE: ./src/images/icons/apple.svg
/* harmony default export */ var apple = ("data:image/svg+xml;base64,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");
;// CONCATENATED MODULE: ./src/images/icons/android.svg
/* harmony default export */ var android = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ./src/components/buttons/cta.module.scss
var cta_module = __webpack_require__(4132);
;// CONCATENATED MODULE: ./src/components/buttons/cta.js








// This needs to be set here since it drives the rendering of the qr.
// Match the CSS for best results.
var qrSize = 74;
var CTAQRCode = function(param) {
    var keyword = param.keyword;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: cta_module.or,
                        children: "or"
                    }),
                    " text ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: keyword
                    }),
                    " to",
                    ' ',
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "50409"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                className: cta_module.qr,
                size: qrSize,
                bgColor: 'transparent',
                value: "smsto:50409?&body=".concat(encodeURIComponent(keyword))
            })
        ]
    }));
};
// Buttons that start a Resist.bot conversation right away
var ResistCTAButtons = function(param) {
    var className = param.className, _keyword = param.keyword, keyword = _keyword === void 0 ? 'resist' : _keyword, _theme = param.theme, theme = _theme === void 0 ? 'blue' : _theme;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(cta_module.ctaBlock, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_button/* default */.Z, {
                theme: theme,
                href: "https://bcrw.apple.com/sms:open?service=iMessage&recipient=urn:biz:d0189b65-f844-4344-adc1-d2d01daca04e&body=".concat(keyword),
                iconSrc: apple,
                children: "iMessage"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_button/* default */.Z, {
                theme: theme,
                href: "sms:50409?&body=".concat(keyword),
                iconSrc: android,
                children: "Text"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAQRCode, {
                keyword: keyword
            })
        ]
    }));
};
CTAQRCode.propTypes = {
    keyword: (prop_types_default()).string.isRequired
};
ResistCTAButtons.propTypes = {
    className: (prop_types_default()).string,
    keyword: (prop_types_default()).string,
    theme: (prop_types_default()).string
};
/* harmony default export */ var cta = (ResistCTAButtons);


/***/ }),

/***/ 5805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ go; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/components/container.js
var container = __webpack_require__(8049);
// EXTERNAL MODULE: ./src/components/layout.js + 10 modules
var layout = __webpack_require__(8492);
// EXTERNAL MODULE: ./src/components/typography/heading.js
var heading = __webpack_require__(9852);
// EXTERNAL MODULE: ./src/components/typography/text.js
var typography_text = __webpack_require__(829);
// EXTERNAL MODULE: ./src/components/buttons/cta.js + 2 modules
var cta = __webpack_require__(3576);
// EXTERNAL MODULE: ./src/components/springboard.module.scss
var springboard_module = __webpack_require__(3280);
;// CONCATENATED MODULE: ./src/components/springboard.js






var Springboard = function(param) {
    var _keyword = param.keyword, keyword = _keyword === void 0 ? 'resist' : _keyword, _message = param.message, message = _message === void 0 ? 'Introduce yourself!' : _message;
    var keywordUpper = keyword.toUpperCase();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: springboard_module.container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                as: 'h2',
                size: 'h2',
                children: message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_text/* default */.Z, {
                className: springboard_module.step,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "1."
                    }),
                    " Tap one of these buttons. It will open up your text app with a prefilled text to Resistbot."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(cta/* default */.Z, {
                keyword: keywordUpper
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_text/* default */.Z, {
                className: springboard_module.step,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "2."
                    }),
                    " Send the text."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_text/* default */.Z, {
                className: springboard_module.step,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "3."
                    }),
                    " Read the texts that come back and follow the directions!"
                ]
            })
        ]
    }));
};
Springboard.propTypes = {
    keyword: (prop_types_default()).string.isRequired,
    message: (prop_types_default()).string.isRequired
};
/* harmony default export */ var springboard = (Springboard);

// EXTERNAL MODULE: ./src/utilities/blockText.js
var blockText = __webpack_require__(9700);
// EXTERNAL MODULE: ./src/utilities/commands.js
var commands = __webpack_require__(7676);
// EXTERNAL MODULE: ./src/utilities/propTypes.js
var propTypes = __webpack_require__(4010);
;// CONCATENATED MODULE: ./src/pages/keyword/go.js









var Go = function(param) {
    var keywords = param.keywords;
    var router = (0,next_router.useRouter)();
    var keyword = router.query.keyword || 'resist'; // Use keyword from query params, otherwise default message.
    // If the command does not exist in CMS, try to get it from command map or use default message.
    var keywordMatch = keywords.find(function(k) {
        return k.keyword === keyword;
    });
    var entry = commands/* allCommandsByName.get */.$2.get(keyword);
    var entryDescription = entry ? entry.command.description : 'Introduce yourself!';
    var message = (keywordMatch === null || keywordMatch === void 0 ? void 0 : keywordMatch.description) ? (0,blockText.toPlainText)(keywordMatch.description) : entryDescription;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        title: "Go: ".concat(keyword),
        description: message,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(springboard, {
                keyword: keyword,
                message: message
            })
        })
    }));
};
Go.propTypes = {
    keywords: prop_types_default().arrayOf(propTypes/* KeywordType */.FO),
    preview: (prop_types_default()).bool
};
var __N_SSG = true;
/* harmony default export */ var go = (Go);


/***/ }),

/***/ 9700:
/***/ (function(module) {

"use strict";

// credit: https://sanity-io-land.slack.com/archives/C9Z7RC3V1/p1606155909114100?thread_ts=1606155317.113300&cid=C9Z7RC3V1
var toPlainText = function(blocks) {
    if (!blocks) return null;
    return blocks.map(function(block) {
        // if it's not a text block with children,
        // return nothing
        if (block._type !== 'block' || !block.children) {
            return '';
        }
        // loop through the children spans, and join the
        // text strings
        return block.children.map(function(child) {
            return child.text;
        }).join('');
    })// join the paragraphs leaving split by two linebreaks
    .join('\n\n');
};
module.exports = {
    toPlainText: toPlainText
};


/***/ }),

/***/ 7676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": function() { return /* binding */ speak; },
/* harmony export */   "Ns": function() { return /* binding */ vote; },
/* harmony export */   "CG": function() { return /* binding */ volunteer; },
/* harmony export */   "vv": function() { return /* binding */ educate; },
/* harmony export */   "JT": function() { return /* binding */ account; },
/* harmony export */   "bJ": function() { return /* binding */ community; },
/* harmony export */   "Kn": function() { return /* binding */ allCommands; },
/* harmony export */   "$2": function() { return /* binding */ allCommandsByName; }
/* harmony export */ });
/* unused harmony export allSections */
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var speak = [
    {
        keyword: 'ceo',
        description: "Contact your state's Chief Election Official (Sec. of State, Lt. Gov. or Election Director)"
    },
    {
        keyword: 'congress',
        description: 'Contact your U.S. Senators & U.S. House representative',
        suggested: true
    },
    {
        keyword: 'dnc',
        description: 'Contact the Democratic National Committee'
    },
    {
        keyword: 'federal',
        description: 'Contact the President and the U.S. Congress'
    },
    {
        keyword: 'house',
        description: 'Contact your representative in the U.S. House'
    },
    {
        keyword: 'gov',
        description: 'Contact your Governor'
    },
    {
        keyword: 'legislature',
        description: 'Contact all your state legislators'
    },
    {
        keyword: 'leo',
        description: 'Contact your local/county election official'
    },
    {
        keyword: 'lower',
        description: 'Contact your state representative(s) or assemblymember(s)'
    },
    {
        keyword: 'mayor',
        description: 'Contact your city or county mayor'
    },
    {
        keyword: 'offices',
        description: 'Get the capitol or local offices for your federal officials'
    },
    {
        keyword: 'officials',
        description: 'List your officials and their phone numbers'
    },
    {
        keyword: 'president',
        description: 'Contact the President'
    },
    {
        keyword: 'senate',
        description: 'Contact one or both of your U.S. Senators'
    },
    {
        keyword: 'sign',
        description: 'Use with a petition code, e.g., <a href="https://resist.bot/petitions/PUCZGE">SIGN PUCZGE</a> to send that petition to your officials'
    },
    {
        keyword: 'state',
        description: 'Contact your Governor and/or state legislators'
    },
    {
        keyword: 'upper',
        description: 'Contact your state senator(s)'
    }, 
];
var vote = [
    {
        keyword: 'check',
        description: 'Check your voter registration & be alerted if it changes'
    },
    {
        keyword: 'early',
        description: 'Find out when and where you can vote early'
    },
    {
        keyword: 'eighteen',
        description: "Get a reminder to register when you're eligible to vote"
    },
    {
        keyword: 'id',
        description: 'Get voter ID requirements & an ID if you need one'
    },
    {
        keyword: 'local',
        description: 'Find and contact your local election office'
    },
    {
        keyword: 'mail',
        description: 'Get vote by mail instructions'
    },
    {
        keyword: 'polls',
        description: 'Find ballot dropboxes and polling places'
    },
    {
        keyword: 'register',
        description: 'Register or pre-register to vote'
    },
    {
        keyword: 'protect',
        description: 'Report an election problem to the nonpartisan Election Protection coalition'
    },
    {
        keyword: 'track',
        description: 'Track your early or mail-in ballot'
    }, 
];
var volunteer = [
    {
        keyword: 'claim',
        description: 'Claim your <a href="/news/2021/05/06/build-your-following">own keyword</a> and amass followers'
    },
    {
        keyword: 'donate',
        description: 'Donate to keep Resistbot running and <a href="/news/2021/08/19/every-donation-now-earns-you-coins">earn coins</a> to spend in-bot'
    },
    {
        keyword: 'drive',
        description: 'Create your own <a href="/news/2020/10/19/vote-registration-and-pledge-drives">voter turnout drive</a> for a race you care about'
    },
    {
        keyword: 'editor',
        description: 'Submit your last letter as a letter to the editor to your local paper'
    },
    {
        keyword: 'follow',
        description: 'Use with a username (e.g., FOLLOW ROSIE) to get text updates from a Resistbot member'
    },
    {
        keyword: 'go',
        description: 'Use with a username (e.g., GO ROSIE) to see and join member campaigns'
    },
    {
        keyword: 'image',
        description: 'Download an image of your last letter'
    },
    {
        keyword: 'import',
        description: 'Turn your <a href="/news/2020/09/17/launch-your-action-network-petitions-on-resistbot">Action Network petition</a> into a Resistbot campaign'
    },
    {
        keyword: 'invite',
        description: 'Invite a friend to try Resistbot',
        suggested: true
    },
    {
        keyword: 'moms',
        description: 'Find local <a href="https://momsdemandaction.org">Moms Demand Action</a> events'
    },
    {
        keyword: 'office',
        description: 'Locate the D.C. or district offices of your Congressional officials'
    },
    {
        keyword: 'petition',
        description: 'Make your last letter a signable <a href="/news/2020/01/14/introducing-petitions">petition</a>'
    },
    {
        keyword: 'promote',
        description: 'Spend coins to <a href="/news/2021/05/18/introducing-rewarded-alerts">promote your petition</a> or vote drive to other Resistbot members'
    },
    {
        keyword: 'run',
        description: 'Find local elected offices to run for with <a href="https://www.runforsomething.net">Run for Something</a>'
    },
    {
        keyword: 'share',
        description: 'Make your last letter <a href="https://twitter.com/openletterbot">an open letter</a>'
    },
    {
        keyword: 'signers',
        description: 'Use with a petition code, e.g., PABCDE, to see how many people have signed a petition and invite more'
    },
    {
        keyword: 'town hall',
        description: 'Find in-person and virtual town halls for your officials'
    },
    {
        keyword: 'turnout',
        description: 'Invite a friend to check and protect their voter registration'
    },
    {
        keyword: 'volunteer',
        description: 'Find phone banks, canvassing, and other volunteer events'
    },
    {
        keyword: 'worker',
        description: 'Find out how you can work the polls during elections'
    }, 
];
var educate = [
    {
        keyword: 'bills',
        description: 'See upcoming bills in the U.S. House'
    },
    {
        keyword: 'donors',
        description: "See the top donors to your Congressional officials' campaigns"
    },
    {
        keyword: 'guns',
        description: 'See how much gun rights and gun safety groups have spent on your representatives'
    },
    {
        keyword: 'nearby',
        description: 'See <a href="https://twitter.com/openletterbot">open letters</a> from your district'
    },
    {
        keyword: 'NRA',
        description: 'See how much the gun manufacturers lobby has spent for/against your representatives'
    },
    {
        keyword: 'page',
        description: 'Get up to three newspaper front pages delivered daily'
    },
    {
        keyword: 'police',
        description: 'See police violence data for your city and state'
    },
    {
        keyword: 'recount',
        description: 'Get a video at the end of each day from <a href="https://therecount.com">The Recount</a>'
    },
    {
        keyword: 'trending',
        description: 'See what <a href="/petitions">petitions</a> are trending right now'
    }, 
];
var account = [
    {
        keyword: 'account',
        description: 'View and change your name, address, and email',
        suggested: true
    },
    {
        keyword: 'alerts',
        description: 'Manage what alerts the bot can send you, like <a href="/news/2021/05/18/introducing-rewarded-alerts">promoted alerts</a>, upcoming town halls, and more'
    },
    {
        keyword: 'close',
        description: 'Use with a petition code, e.g., PABCDE, to close a petition'
    },
    {
        keyword: 'coins',
        description: 'See how many Resistbot coins you have'
    },
    {
        keyword: 'commands',
        description: 'Get a list of these commands'
    },
    {
        keyword: 'emails',
        description: 'Manage what kinds of emails the bot can send you'
    },
    {
        keyword: 'feedback',
        description: 'Leave product feedback for the volunteers'
    },
    {
        keyword: 'following',
        description: "See who you're following"
    },
    {
        keyword: 'oops',
        description: 'Rejoin after unsubscribing'
    },
    {
        keyword: 'pair',
        description: 'Use from iMessage or Telegram to pair your SMS account'
    },
    {
        keyword: 'petitions',
        description: "See all petitions you've created"
    },
    {
        keyword: 'preferences',
        description: 'Change bot behaviors'
    },
    {
        keyword: 'stats',
        description: 'See your usage stats and followers'
    },
    {
        keyword: 'stop',
        description: 'Cancel the service completely'
    },
    {
        keyword: 'subscribe',
        description: 'Start a new monthly donation or change/cancel your existing one'
    },
    {
        keyword: 'support',
        description: 'If you can’t find an answer on my <a href="/about">help page</a> you can get help with your account here',
        suggested: true
    },
    {
        keyword: 'upgrade',
        description: 'Upgrade your SMS account to iMessage or Telegram'
    }, 
];
var community = [
    {
        keyword: 'blood',
        description: 'Find a local non-profit community blood center'
    },
    {
        keyword: 'coverage',
        description: 'Learn how to get ACA coverage'
    },
    {
        keyword: 'covid',
        description: 'See current mandates and what’s open and closed in your state'
    },
    {
        keyword: 'covid act',
        description: 'Get state and county pandemic data from <a href="https://covidactnow.org">COVID Act Now</a>'
    },
    {
        keyword: 'covid test',
        description: 'Find COVID testing sites near you'
    },
    {
        keyword: 'csa',
        description: 'Find Community-Supported Agriculture near you'
    },
    {
        keyword: 'food',
        description: 'Find your nearest food banks'
    },
    {
        keyword: 'hospitals',
        description: 'Data on your local hospital capacities and COVID patients'
    },
    {
        keyword: 'mutual aid',
        description: 'Find your nearest mutual aid networks'
    },
    {
        keyword: 'snap',
        description: 'Learn how to get SNAP benefits in your state'
    },
    {
        keyword: 'vaccine',
        description: 'Find your nearest vaccination location'
    }, 
];
var allCommands = _toConsumableArray(account).concat(_toConsumableArray(community), _toConsumableArray(educate), _toConsumableArray(speak), _toConsumableArray(volunteer), _toConsumableArray(vote));
var allSections = {
    speak: speak,
    vote: vote,
    volunteer: volunteer,
    educate: educate,
    community: community,
    account: account
};
var allCommandsByName = new Map();
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = Object.entries(allSections)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var _value = _slicedToArray(_step.value, 2), section = _value[0], commands = _value[1];
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = commands[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var command = _step1.value;
                allCommandsByName.set(command.keyword, {
                    command: command,
                    section: section
                });
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}


/***/ }),

/***/ 4010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T7": function() { return /* binding */ BlogPostDetailType; },
/* harmony export */   "XW": function() { return /* binding */ BlogPostTileType; },
/* harmony export */   "bg": function() { return /* binding */ LetterType; },
/* harmony export */   "WT": function() { return /* binding */ SiteStatsType; },
/* harmony export */   "Ni": function() { return /* binding */ PetitionType; },
/* harmony export */   "iU": function() { return /* binding */ PetitionTypeList; },
/* harmony export */   "Y4": function() { return /* binding */ MerchType; },
/* harmony export */   "Jp": function() { return /* binding */ SanityMerchImageType; },
/* harmony export */   "FO": function() { return /* binding */ KeywordType; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utilities_proptype_validators__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9685);


var SanityImageType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    asset: prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
        url: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
    }).isRequired
}).isRequired;
var SanityMerchImageType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    altText: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    asset: prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
        url: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
    }).isRequired
}).isRequired;
var BlogPostDetailType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    id: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    slug: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    route: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    publishedAt: utilities_proptype_validators__WEBPACK_IMPORTED_MODULE_1__/* .ISODateValidator */ .L,
    lastUpdated: utilities_proptype_validators__WEBPACK_IMPORTED_MODULE_1__/* .ISODateValidator */ .L,
    title: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    description: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({})).isRequired,
    mainImage: SanityImageType,
    body: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({})).isRequired,
    featuredKeyword: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    authors: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
        name: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
    })),
    category: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    tags: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({}))
}).isRequired;
var BlogPostTileType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    id: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    slug: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    route: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    publishedAt: utilities_proptype_validators__WEBPACK_IMPORTED_MODULE_1__/* .ISODateValidator */ .L,
    title: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    description: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({})).isRequired,
    mainImage: SanityImageType,
    category: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
}).isRequired;
var LetterType = (prop_types__WEBPACK_IMPORTED_MODULE_0___default().object);
var SiteStatsType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    lettersSent: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    recurringDonors: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    targetRecurringDonors: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    users: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    voterRegistrations: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired)
});
var PetitionType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    petition_code: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    petitioner_code: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    subject: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    message: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    petitioner_name: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    state: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    sent_timestamp: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    target: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    sign_count: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    sign_status: prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOf([
        'open',
        'closed'
    ]),
    trending: prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
        sign_count_period: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number)
    }).isRequired
});
var PetitionTypeList = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    petition_code: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    subject: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    state: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    sent_timestamp: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    target: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    sign_count: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    sign_status: prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOf([
        'open',
        'closed'
    ]),
    trending: prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
        sign_count_period: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number)
    })
});
var MerchType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    _id: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    image: SanityMerchImageType,
    name: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    link: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
});
var KeywordType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    keyword: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    description: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_0___default().object))
});



/***/ }),

/***/ 959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__min1b","small":"button_small__9ZMRl","medium":"button_medium__bH1Hz","large":"button_large__UygIj","full":"button_full__ATHy_","icon":"button_icon__imq3_","blue":"button_blue__tBWUT","light":"button_light__5OWv6","midnight":"button_midnight__4HV6B","outline":"button_outline__VnTGJ"};

/***/ }),

/***/ 4132:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaBlock":"cta_ctaBlock__iXsYL","or":"cta_or__Oeebd","ctaHeading":"cta_ctaHeading__wWUnB","qr":"cta_qr__lJ4lF"};

/***/ }),

/***/ 3280:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"springboard_container__Iv7r6","step":"springboard_step__ivlA3"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [569,193,498,323,774,888,179], function() { return __webpack_exec__(688); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);